import { createContext } from 'react'

interface HinweisContextType {
  setHinweis: (title: string, text: string, instruction?: string) => void
}

const HinweisContext = createContext<HinweisContextType>({
  setHinweis: () => {}
})

export default HinweisContext
